import styled from 'styled-components';

export const StyledEmailHistory = styled.div`
  .Polaris-IndexTable__TableHeading.Polaris-IndexTable__TableHeading--first,
  .Polaris-IndexTable__TableCell.Polaris-IndexTable__TableCell--first {
    display: none;
  }
`;
